// colors
import {grey} from '@drivesally/sally-ui/lib/libs/colors';

// components
import Button from '@drivesally/sally-ui/lib/components/Button/Button';
import Input from '@drivesally/sally-ui/lib/components/Input/Input';
import Textarea from '@drivesally/sally-ui/lib/components/Textarea/Textarea';

// layout components
import CompactDataRow from '../../../layout/components/CompactDataRow/CompactDataRow';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Fragment} from 'react';

// styled-components
import styled from 'styled-components';

const DEFAULT_SERVICE = {
  name: '',
  phone_number: '',
  service_description: '',
};

const ServiceGroup = styled.div`
  border-bottom: 1px solid ${grey};

  &:last-of-type {
    border-bottom: none;
  }
`;

const TowingJumpServicesEditor = ({onChange, services = []}) => {
  const changeService = (index, key) => (value) => {
    const updatedServices = [...services];
    updatedServices[index] = {...updatedServices[index], [key]: value};
    onChange(updatedServices);
  };

  const removeService = (index) => () => {
    onChange(
      [...services].filter((_service, serviceIndex) => serviceIndex !== index)
    );
  };

  const addService = () => {
    onChange([...services, {...DEFAULT_SERVICE}]);
  };

  return (
    <Fragment>
      {services.map((service, index) => (
        <ServiceGroup key={index}>
          <CompactDataRow label="Name" wrapContent noPadding>
            <Input
              value={service.name || ''}
              onChange={changeService(index, 'name')}
              size="small"
              placeholder="Name"
              flat
            />
          </CompactDataRow>
          <CompactDataRow label="Phone Number" wrapContent noPadding>
            <Input
              value={service.phone_number || ''}
              onChange={changeService(index, 'phone_number')}
              size="small"
              placeholder="Phone Number"
              flat
            />
          </CompactDataRow>
          <CompactDataRow label="Description">
            <Textarea
              value={service.service_description || ''}
              onChange={changeService(index, 'service_description')}
              size="small"
              placeholder="Service Description"
            />
          </CompactDataRow>
          <CompactDataRow>
            <Button
              theme="transparent"
              color="darkGrey"
              icon="delete"
              size="small"
              onClick={removeService(index)}
            >
              Remove
            </Button>
          </CompactDataRow>
        </ServiceGroup>
      ))}
      <CompactDataRow>
        <Button theme="grey" icon="plus" size="small" onClick={addService}>
          Add
        </Button>
      </CompactDataRow>
    </Fragment>
  );
};

TowingJumpServicesEditor.propTypes = {
  onChange: PropTypes.func,
  services: PropTypes.array,
};

export default TowingJumpServicesEditor;
